import React from 'react';
import { Button, Card, Descriptions, Tag } from 'antd';
import { getValueWithUnit } from '../../../common/utils';
import { appConfig } from '../../../common/config';

interface IDeviceDetailsProps {
  device: any;
  onInstall: (serial: string) => void;
}

const DeviceDetails: React.FC<IDeviceDetailsProps> = ({device, onInstall}) => {
  const isLevelSense = device.DeviceTypeName.startsWith('LevelSense');
  const isPeopleSense = device.DeviceTypeName.startsWith('PeopleSense');

  if (!device) return null;

  const measurements = device?.Measurements;
  const installationData = device?.InstallationData;
  const batteryStatus = appConfig.getBatteryStatus(measurements?.['Battery Voltage']);
  const rssiStatus = appConfig.getRssiStatus(device?.RSSI);
  const level = measurements?.Level;
  const ultrasonicDistance = measurements?.['Ultrasonic Distance'];

  return (
    <>
      <Card size='small' title='Current Status' headStyle={{ textAlign: 'center' }} variant="borderless">
      <Descriptions column={1} size='small'>
        {
          isLevelSense && <>
          {
            level !== undefined && <Descriptions.Item label="Bin Level">{getValueWithUnit(level, '%')}</Descriptions.Item>
          }
          {
            level === undefined && <Descriptions.Item label="Ultrasonic Distance">{getValueWithUnit(ultrasonicDistance, 'cm')}</Descriptions.Item>
          }
          </>
        }
        <Descriptions.Item label="Battery"><Tag color={batteryStatus.color}>{batteryStatus.text}</Tag></Descriptions.Item>
        {rssiStatus && <Descriptions.Item label="Signal Strength (RSSI)"><Tag color={rssiStatus.color}>{rssiStatus.text}</Tag></Descriptions.Item>}
        {
          isPeopleSense && <>
            <Descriptions.Item label="Total Count">{getValueWithUnit(measurements?.['Total Count'], '')}</Descriptions.Item>
          </>
        }

      </Descriptions>
    </Card>
    <Card size='small' title='Properties' headStyle={{ textAlign: 'center' }} variant="borderless">
      <Descriptions column={1} size='small'>
        <Descriptions.Item label="Device Type">{device['DeviceTypeName']}</Descriptions.Item>
      </Descriptions>
    </Card>
    {
      isLevelSense && <Card size='small' title='Settings' headStyle={{ textAlign: 'center' }} variant="borderless">
        <Descriptions column={1} size='small'>
          <Descriptions.Item label="Empty Distance">{getValueWithUnit(installationData?.EmptyDistance, 'cm')}</Descriptions.Item>
          <Descriptions.Item label="Full Distance">{getValueWithUnit(installationData?.FullDistance, 'cm')}</Descriptions.Item>
        </Descriptions>
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <Button type="primary" onClick={() => onInstall(device?.SerialNumber)} style={{ padding: 8, minWidth: 120 }}>Install</Button>
        </div>
      </Card>
    }
    </>
  );
};

export default DeviceDetails;